import { strapi } from "@strapi/client";

import { config } from "@shared/config";

export const strapiClient = strapi({
  baseURL: `${config.api.strapiUrl}/api`,
  auth: config.api.strapiApiToken,
});
